
export const registerTypeList = [
  {key: '원청사근로자', label: '원청사 근로자', value: '원청사근로자'},
  {key: '원청사장비운전자', label: '원청사 장비운전자', value: '원청사장비운전자'},
  {key: '협력사근로자', label: '협력사 근로자', value: '협력사근로자'},
  {key: '협력사장비운전자', label: '협력사 장비운전자', value: '협력사장비운전자'},
  {key: '기타', label: '기타', value: '기타'},
]

export function getRegisterTypeInfo(key) {
  const type = registerTypeList.find(item => item.key === key);
  return type ? { value: type.value, label: type.label } : null;
}
